import { AllStatsDIRResponse } from '../../../types/api/endpoints/stats/stats.types';
import { STATS_ENDPOINTS } from '../../../utils/api/endpoints/statsEndpoints';

const PREFIX = '[allStatsDIRQuery]';

export const queryAllStatsDIR = async () => {
  console.log(PREFIX, `Fetching all DIR stats...`);
  const response = await STATS_ENDPOINTS.allStatsDIR();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received all DIR stats.`);
  return json as AllStatsDIRResponse;
};
